__turbopack_context__.v({
  "ageBug": "SharpnessStoryItem-module-scss-module___ajiHG__ageBug",
  "cheddarCheeseCurds": "SharpnessStoryItem-module-scss-module___ajiHG__cheddarCheeseCurds",
  "copy": "SharpnessStoryItem-module-scss-module___ajiHG__copy",
  "cta": "SharpnessStoryItem-module-scss-module___ajiHG__cta",
  "ctaInner": "SharpnessStoryItem-module-scss-module___ajiHG__ctaInner",
  "ctaInnerText": "SharpnessStoryItem-module-scss-module___ajiHG__ctaInnerText",
  "ctas": "SharpnessStoryItem-module-scss-module___ajiHG__ctas",
  "detailsCopy": "SharpnessStoryItem-module-scss-module___ajiHG__detailsCopy",
  "detailsCopyInner": "SharpnessStoryItem-module-scss-module___ajiHG__detailsCopyInner",
  "detailsCopyInnerHeight": "SharpnessStoryItem-module-scss-module___ajiHG__detailsCopyInnerHeight",
  "extraSharpCheddar": "SharpnessStoryItem-module-scss-module___ajiHG__extraSharpCheddar",
  "fade-in": "SharpnessStoryItem-module-scss-module___ajiHG__fade-in",
  "headline": "SharpnessStoryItem-module-scss-module___ajiHG__headline",
  "headlineWrapper": "SharpnessStoryItem-module-scss-module___ajiHG__headlineWrapper",
  "imageWrapper": "SharpnessStoryItem-module-scss-module___ajiHG__imageWrapper",
  "inner": "SharpnessStoryItem-module-scss-module___ajiHG__inner",
  "isPage": "SharpnessStoryItem-module-scss-module___ajiHG__isPage",
  "makersLogo": "SharpnessStoryItem-module-scss-module___ajiHG__makersLogo",
  "makersLogoIcon": "SharpnessStoryItem-module-scss-module___ajiHG__makersLogoIcon",
  "makersReserve": "SharpnessStoryItem-module-scss-module___ajiHG__makersReserve",
  "makersSharpnessYear": "SharpnessStoryItem-module-scss-module___ajiHG__makersSharpnessYear",
  "makersSharpnessYearGraphic": "SharpnessStoryItem-module-scss-module___ajiHG__makersSharpnessYearGraphic",
  "mediumCheddar": "SharpnessStoryItem-module-scss-module___ajiHG__mediumCheddar",
  "root": "SharpnessStoryItem-module-scss-module___ajiHG__root",
  "sharpCheddar": "SharpnessStoryItem-module-scss-module___ajiHG__sharpCheddar",
  "theme--makers-reserve": "SharpnessStoryItem-module-scss-module___ajiHG__theme--makers-reserve",
  "unorderedList": "SharpnessStoryItem-module-scss-module___ajiHG__unorderedList",
});
